<div class="title">
  გსურს მგზავრების დამატება?
</div>
<small><i class="fas fa-info-circle me-2"></i>თუ მარტო არ მიემგზავრები, დააზღვიე სხვა მოგზაურიც</small>

  <div class="d-flex mt-5">
    <a class="Btn Btn--link pos-r yes next" (click)="yes()">დიახ</a>
    <a class="Btn Btn--link pos-r no next" (click)="no()">არა</a>
  </div>

<div class="sheet-buttons g g--spaceAround g--wrap g--nowrap@s g--alignEnd mt-5">
  <app-prev-btn></app-prev-btn>
</div>
